import Swiper from 'swiper';
import {Navigation, Pagination, Thumbs} from 'swiper/modules';

export default class ProductSwiper {
    constructor() {
        this.mainSwiper = null;
        this.thumbsSwiper = null;
        this.resizeTimeout = null;
        this.init();
    }

    init() {
        // Wait for DOM to be ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.delayedInit();
            });
        } else {
            this.delayedInit();
        }
    }

    delayedInit() {
        // Small delay to ensure all elements are rendered
        setTimeout(() => {
            this.initSwipers();
            this.setupResizeListener();
        }, 100);
    }

    initSwipers() {
        try {
            const thumbsSlider = document.querySelector('.swiper-thumbs');
            const mainSlider = document.querySelector('.swiper-main');

            // Exit if main slider doesn't exist
            if (!mainSlider) {
                console.log('Product swiper: Main slider not found on this page');
                return;
            }

            // Check if swiper-wrapper exists
            const mainWrapper = mainSlider.querySelector('.swiper-wrapper');
            if (!mainWrapper) {
                console.error('Product swiper: Main swiper-wrapper not found');
                return;
            }

            // Initialize thumbnail slider if it exists
            if (thumbsSlider && thumbsSlider.querySelector('.swiper-wrapper')) {
                this.thumbsSwiper = new Swiper(thumbsSlider, {
                    modules: [Thumbs],
                    spaceBetween: 10,
                    slidesPerView: 'auto',
                    freeMode: true,
                    watchSlidesProgress: true,
                    observer: false,
                    observeParents: false,
                    watchOverflow: true,
                    slideToClickedSlide: true,
                });
            }

            // Initialize main slider
            this.mainSwiper = new Swiper(mainSlider, {
                modules: [Navigation, Pagination, Thumbs],
                spaceBetween: 10,
                slidesPerView: 1,
                loop: false,
                observer: false,
                observeParents: false,
                observeSlideChildren: false,
                updateOnWindowResize: false,
                resizeObserver: false,
                navigation: {
                    enabled: false
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                thumbs: this.thumbsSwiper ? {
                    swiper: this.thumbsSwiper,
                } : undefined,
                on: {
                    init: function () {
                        console.log('Product swiper initialized successfully');
                    },
                },
            });

            // Listen for variant changes
            this.setupVariantChangeListener();
        } catch (error) {
            console.error('Error initializing product swiper:', error);
        }
    }

    setupVariantChangeListener() {
        // Listen for Shopify's variant:change event
        document.addEventListener('variant:change', (event) => {
            if (!this.mainSwiper || !event.detail) return;

            const variant = event.detail.variant;
            if (!variant || !variant.featured_media) return;

            this.switchToMedia(variant.featured_media.id);
        });

        // Also listen for custom events from variant selectors
        const variantSelects = document.querySelector('variant-selects');
        if (variantSelects) {
            variantSelects.addEventListener('change', () => {
                const selectedVariantInput = document.querySelector('[name="id"]');
                if (!selectedVariantInput) return;

                // Get variant data from the variant-selects element
                const variantData = variantSelects.currentVariant;
                if (variantData && variantData.featured_media) {
                    this.switchToMedia(variantData.featured_media.id);
                }
            });
        }
    }

    switchToMedia(mediaId) {
        if (!this.mainSwiper) return;

        // Find the slide index with matching media-id
        const slides = this.mainSwiper.slides;
        let targetIndex = -1;

        for (let i = 0; i < slides.length; i++) {
            const slideMediaId = slides[i].getAttribute('data-media-id');
            if (slideMediaId && slideMediaId === String(mediaId)) {
                targetIndex = i;
                break;
            }
        }

        // Switch to the slide if found
        if (targetIndex >= 0 && targetIndex !== this.mainSwiper.activeIndex) {
            this.mainSwiper.slideTo(targetIndex, 300);
            console.log(`Switched to slide ${targetIndex} for media ${mediaId}`);
        }
    }

    setupResizeListener() {
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                // Only update on significant size changes
                if (this.mainSwiper) {
                    this.mainSwiper.update();
                }
                if (this.thumbsSwiper) {
                    this.thumbsSwiper.update();
                }
            }, 500);
        });
    }

    destroy() {
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
        if (this.mainSwiper) {
            this.mainSwiper.destroy(true, true);
            this.mainSwiper = null;
        }
        if (this.thumbsSwiper) {
            this.thumbsSwiper.destroy(true, true);
            this.thumbsSwiper = null;
        }
    }
}

// Auto-initialize
if (typeof window !== 'undefined') {
    window.productSwiper = new ProductSwiper();

    // Cleanup on page unload
    window.addEventListener('beforeunload', () => {
        if (window.productSwiper) {
            window.productSwiper.destroy();
        }
    });
}
